import DownloadIcon from "@assets/images/down-arrow.svg";
import { Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { FilterPageProps, PageListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import FinanceOrderList from "../FinanceOrderList";
import { PayoutOrders_storeOrdersPayout_edges_node } from "./../../types/PayoutOrders";
import {
  createFilterStructure,
  FinanceOrderFilterKeys,
  FinanceOrderListFilterOpts
} from "./filters";

const useStyles = makeStyles(
  theme => ({
    download: {
      backgroundColor: "#FFD15C",
      borderRadius: "6px",
      height: "35px",
      width: "35px",
      margin: theme.spacing(0, 2)
    },
    imgDownload: {
      width: "20px"
    },
    expressForPayment: {
      margin: theme.spacing(0, 0),
      backgroundColor: "#FFD15C",
      borderRadius: "6px",
      height: "35px"
    }
  }),
  { name: "FinanceOrderListPage" }
);

export interface FinanceOrderListPage
  extends PageListProps,
    TabPageProps,
    FilterPageProps<FinanceOrderFilterKeys, FinanceOrderListFilterOpts> {
  orders: PayoutOrders_storeOrdersPayout_edges_node[];
  currencySymbol;
  download: () => void;
  expressForPayment: () => void;
  initialSearch;
  onFilterChange;
  filterOpts;
  activeTab;
  isChecked;
  selected;
  toggle;
  toggleAll;
  toolbar;
  settings;
  onSearchChange;
  params;
  customAction;
}

const FinanceOrderListPage: React.FC<FinanceOrderListPage> = props => {
  const {
    activeTab,
    currencySymbol,
    currentTab,
    initialSearch,
    filterOpts,
    tabs,
    // onAdd,
    onAll,
    onSearchChange,
    onFilterChange,
    onTabChange,
    // onTabDelete,
    // onTabSave,
    download,
    expressForPayment,
    params,
    customAction,
    ...listProps
  } = props;
  const intl = useIntl();
  const filterStructure = createFilterStructure(intl, filterOpts, params);
  const classes = useStyles(props);
  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.orders)}>
        {params.payoutStatus === "OPEN" && (
          <>
            <Button
              color="primary"
              variant="contained"
              onClick={expressForPayment}
            >
              Express for Payment
            </Button>
            <IconButton
              color="primary"
              className={classes.download}
              onClick={download}
            >
              <img src={DownloadIcon} className={classes.imgDownload} />
            </IconButton>
          </>
        )}
      </PageHeader>

      <Card>
        <FilterBar
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          initialSearch=""
          // onAll={() => {
          //   // eslint-disable-next-line no-console
          //   console.log("On All");
          // }}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={() => {
            // eslint-disable-next-line no-console
            console.log("On Tab Delete");
          }}
          onTabSave={() => {
            // eslint-disable-next-line no-console
            console.log("On Tab Save");
          }}
          tabs={tabs}
          allTabLabel={intl.formatMessage({
            defaultMessage: "Open Orders",
            description: "open orders"
          })}
          filterStructure={filterStructure}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Order Code"
          })}
          disablePlusOneTab={true}
          hideAction={true}
          customAction={customAction}
        />
        <FinanceOrderList {...listProps} params={params} />
      </Card>
    </Container>
  );
};

export default FinanceOrderListPage;
